import API from './resources'

const actions = {
  async groups({ commit }, payload) {
    try {
      const response = await API.getGroups(
        payload
        )
      commit('SET_GROUPS', response.data)
      return response.data
    } catch (error) {
      return error
    }
  },
  async postLogs (_, payload) {
    let data, token
    [ data, token ] = payload
    try {

      const response = await API.postCreateLogs(data, token)
      return response
    } catch (error) {
      return error
    }
  },
  async postSmsList (_, payload) {
    let data, token
    [ data, token ] = payload
    try {

      const response = await API.postSmsList(data, token)
      return response
    } catch (error) {
      return error
    }
  },
  async getGroups({ commit }, payload) {
    try {
      const response = await API.getAllGroups(payload)
      commit('SET_SMS_LIST', response.data.content)
      return response
    } catch (error) {
      return error
    }
  },
  //edição
    async updateSmsList(_, payload) {
      let data, token
      [ data, token ] = payload
      try {
        const response = await API.updateSmsList(data, token)
        return response
      } catch (error) {
        return error
      }
    },
    async disableSmsList({ commit }, payload) {
      let data, token
      [ data, token ] = payload
      try {
        const response = await API.disableSmsList(data, token)
        return response
      } catch (error) {
        return error
      }
    },
    async getSmsList({ commit, state }, payload) {
      try {
        if (state.is_active === null)  {
          const response = await API.getSmsLists(
               state.group_name,
               state.id_push_moe,
               state.is_active,
               state.updated_at,
            )

          commit('SET_SMSGROUP_LIST', response.data)
          commit('SET_SMSGROUP_PAGINATION', response.data)
        }
      } catch (error) {
        return error
      }
    },
  async getFilteredSmsList({ commit }, payload) {
    try {
      const response = await API.getFilteredSmsLists(payload)
      commit('SET_SMS_LIST', response.data.content)
      return response
    } catch (error) {
      return error
    }
  },
}

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/messageForm/actions.js